function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  x: -50,
  y: -50,
  width: 200,
  height: 200,
  name: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  result: "shadowOffsetOuter1",
  dy: 1,
  in: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "shadowBlurOuter1",
  stdDeviation: 0.5,
  in: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0",
  in: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  result: "shadowOffsetOuter2",
  in: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "shadowBlurOuter2",
  stdDeviation: 0.5,
  in: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  result: "shadowMatrixOuter2",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
  in: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "\n        btn_google_light_normal_ios\n    ");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 40,
  height: 40,
  rx: 2,
  fill: "#fff"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.64,23.2a11,11,0,0,0-.16-1.84H23v3.49h4.84a4.12,4.12,0,0,1-1.79,2.71v2.26H29a8.78,8.78,0,0,0,2.68-6.62Z",
  fill: "#4285f4",
  fillRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23,32a8.62,8.62,0,0,0,6-2.18l-2.91-2.26a5.43,5.43,0,0,1-3.05.86,5.37,5.37,0,0,1-5-3.71H15V27a9,9,0,0,0,8,5Z",
  fill: "#34a853",
  fillRule: "evenodd"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18,24.71a5.36,5.36,0,0,1,0-3.42V19H15A9,9,0,0,0,15,27l3-2.33Z",
  fill: "#fbbc05",
  fillRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23,17.58a4.83,4.83,0,0,1,3.44,1.35L29,16.34A8.65,8.65,0,0,0,23,14a9,9,0,0,0-8,5l3,2.33a5.37,5.37,0,0,1,5-3.71Z",
  fill: "#ea4335",
  fillRule: "evenodd"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M14,14H32V32H14Z",
  fill: "none"
});

var SvgGoogleLogo = function SvgGoogleLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-logo.a34f24a1.svg";
export { ForwardRef as ReactComponent };